import { initParticlesEngine } from '@tsparticles/react'
import { loadSlim } from '@tsparticles/slim'
import { loadEmittersPlugin } from '@tsparticles/plugin-emitters'
import { loadEmittersShapeCircle } from '@tsparticles/plugin-emitters-shape-circle'
import { loadEmittersShapeSquare } from '@tsparticles/plugin-emitters-shape-square'

/**
 * Single shared tsparticles engine for the whole app.
 *
 * Previously the app initialized two engines: `loadSlim` (background) and
 * `loadFull` (data-flow header animation). The full bundle alone is ~150KB+.
 * The slim bundle plus the emitters plugin covers everything both
 * animations need, loaded exactly once.
 */
let enginePromise: Promise<void> | null = null

export const ensureParticlesEngine = (): Promise<void> => {
	if (!enginePromise) {
		enginePromise = initParticlesEngine(async (engine) => {
			await loadSlim(engine)
			await loadEmittersPlugin(engine)
			await loadEmittersShapeCircle(engine)
			await loadEmittersShapeSquare(engine)
		})
	}
	return enginePromise
}
